var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXpektorLogoNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 41,
    viewBox: "0 0 149 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.4139 9.99609C34.6992 9.99609 32.0955 11.7165 30.6542 14.0411L30.5595 10.2316H26.5605V40.1186H30.6542V29.5248C32.0034 31.7034 34.4201 33.2395 38.1375 33.2395C44.5045 33.2395 48.7825 28.3573 48.7825 21.34C48.7825 14.3227 44.5992 9.99609 38.4139 9.99609ZM37.861 29.7475C32.8841 29.7475 30.6542 25.5207 30.6542 22.0825V21.0559C30.6542 17.7123 32.9788 13.4856 37.9557 13.4856C42.0442 13.4856 44.6018 16.5961 44.6018 21.4348C44.6018 26.2734 41.9495 29.7475 37.861 29.7475Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2817 21.6626C71.2817 14.3176 67.2828 9.99609 60.9131 9.99609C54.5435 9.99609 50.0352 14.8347 50.0352 21.6626C50.0352 28.4905 53.8958 33.2395 61.0079 33.2395C67.0984 33.2395 70.2551 29.9395 71.1434 25.7998H67.0037C66.5813 27.6584 65.0503 29.7501 61.0514 29.7501C57.0525 29.7501 54.5896 27.0107 54.2671 22.6892H71.2817V21.6626ZM54.3618 19.6657C55.0095 15.8562 57.4723 13.4881 60.9567 13.4881C64.441 13.4881 66.6325 15.5797 67.1419 19.6657H54.3618Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6342 19.9946L92.5588 10.2303H87.4002L77.5846 21.0571V0H73.4961V33.0078H77.5846V26.546L80.9794 22.8312L88.6521 33.0103H93.4395L83.6316 19.9972L83.6342 19.9946Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100.519 10.2297V3.44531H96.6584V10.2297H95.171L91.8633 13.7626H96.4254V25.5239C96.4254 30.2678 99.5872 33.2401 104.892 33.2401C106.013 33.2401 107.114 33.0942 107.895 32.8842V29.2565C107.042 29.5638 106.19 29.6636 105.309 29.6636C101.594 29.6636 100.522 27.7973 100.522 25.5239V13.6679H107.91V10.2297H100.522H100.519Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M120.566 9.99609C113.825 9.99609 109.316 14.9218 109.316 21.8521C109.316 28.7823 113.827 33.2395 120.566 33.2395C127.304 33.2395 131.858 28.4521 131.858 21.573C131.858 14.6939 127.399 9.99609 120.566 9.99609ZM120.566 29.7475C116.331 29.7475 113.497 26.4987 113.497 21.7112C113.497 16.9238 116.331 13.4856 120.566 13.4856C124.8 13.4856 127.678 16.8726 127.678 21.7112C127.678 26.5499 124.887 29.7475 120.566 29.7475Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M148.999 10.2305V13.6687H138.162V33.0079H134.076V10.2305H148.999Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1709 21.6298H7.71879L7.62407 21.4992L0.373779 10.8107L0 10.25H4.45207L4.54167 10.378L11.7996 21.0665L12.1709 21.6298Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9212 21.6295H15.8945L15.9079 21.6055L15.9212 21.6295Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7993 32.8751L12.5439 22.1866L12.2598 21.7539L19.5152 32.4424L19.7993 32.8751Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3388 33.0048H19.8868L19.7972 32.8742L12.5417 22.1857L12.2576 21.753L12.168 21.625H16.6226L16.7173 21.753L23.9676 32.4415L24.3388 33.0048Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1813 21.6055L12.1946 21.6295H12.168L12.1813 21.6055Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3422 10.25L23.971 10.8107L16.7207 21.4992L16.6363 21.6067L16.2778 21.0665L14.4141 18.3144L19.8006 10.378L19.8902 10.25H24.3422Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94099 24.9173L4.54167 32.8742L4.45207 33.0048H0L0.373779 32.4415L7.62407 21.753L7.71879 21.625L8.09001 22.1857L9.94099 24.9173Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXpektorLogoNew);
export default __webpack_public_path__ + "static/media/xpektor_logo_new.3e4e01f5be2461a72edddaeba9ec5395.svg";
export { ForwardRef as ReactComponent };